import { render, staticRenderFns } from "./PatientIndexComponent.vue?vue&type=template&id=6563842f"
import script from "./PatientIndexComponent.vue?vue&type=script&lang=js"
export * from "./PatientIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports